import React from 'react';
import { connect } from 'react-redux';
import { FooterType } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { FooterVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { FooterComponentProps, mapStateToProps } from 'component/page/detail/DetailPageModularize/ContentsHandler/FooterComponent.selectors';
import { OfferCardFooterType } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter.selectors';
import AvailableDetailPrice from 'component/page/detail/AvailableDetailPrice/AvailableDetailPrice';
import OfferCardFooter from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter';

interface DynamicFooterProps {
    footerType: FooterType;
}

const DynamicFooter: React.FC<DynamicFooterProps> = (props) => {
    switch (props.footerType) {
        case FooterType.Booking:
            // We only have one DetailsFooter so we use first index
            return <OfferCardFooter footerType={OfferCardFooterType.Sticky} offerIndex={0} />;
        case FooterType.Details:
            return <AvailableDetailPrice.Footer />;
        default:
            return null;
    }
};
DynamicFooter.displayName = 'FooterComponent';

const FooterComponent: React.FC<FooterComponentProps> = (props) => {
    switch (props.variant) {
        case FooterVariant.Default:
            return <DynamicFooter footerType={props.footerType} />;
        case FooterVariant.BookingOnly:
            return props.isSelectedOfferCardExist ? <DynamicFooter footerType={FooterType.Booking} /> : null;
        case FooterVariant.SeeOptionOnly:
            return <AvailableDetailPrice.Footer isOverlay={true} />;
        default:
            return null;
    }
};
FooterComponent.displayName = 'FooterComponent';

export default connect(mapStateToProps)(FooterComponent);
